import People from "../../../../src/components/people";
import { people, candidateTableData, tableHeaders } from "../../../../src/data/data-2021.js";
import * as React from 'react';
export default {
  People,
  people,
  candidateTableData,
  tableHeaders,
  React
};